import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/hyrelancer_frontend/hyrelancer/src/app/(public)/servicelist/components/ServicesHome.jsx");
